<template>
  <div>
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('bankAccountEdit.collapseTitle.bankTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <bank-form ref="bankForm" :canEdit="canEdit" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('bankAccountEdit.collapseTitle.accountTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <account-form ref="accountForm" :sysAccountList="sysAccountList" :canEdit="canEdit" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021050810445354695']"
        v-if="this.$route.name.indexOf('Details') != -1"
        type="primary"
        @click="canEdit = !canEdit"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.editToggle') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050810444173793']"
        type="primary"
        @click="save('001')"
        :loading="loading"
        :disabled="!canEdit"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.save') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import bankForm from './components/bankForm'; // 开户行信息
  import accountForm from './components/accountForm'; // 开户行信息
  import API from '@/api/financeCenter/bankAccount';
  // import { resolve, reject } from 'q';
  import loading from '@/common/js/load.js'; //loading

  export default {
    name: 'baseEdit',
    components: {
      bankForm,
      accountForm,
    },
    data() {
      return {
        canEdit: true,
        loading: false,
        activeNames: ['1', '2'],
        sysAccountList: [], //科目列表
      };
    },
    computed: {},
    mounted() {
      this.getAccount();
      if (this.$route.name.indexOf('Add') == -1) {
        if (this.$route.name.indexOf('Details') != -1) {
          this.canEdit = false;
        }
        this.getDetail();
      }
    },
    methods: {
      getDetail() {
        // 请求详情
        this.loading = true;
        const params = {
          id: this.$route.query.id,
        };
        this.$axios.post(API.QUERY_BANKACCOUNT_BY_ID, params).then((res) => {
          if (res.data.code == 0) {
            this.loading = false;
            let allDetail = res.data.data;
            let [bankForm, accountForm] = [
              this.$refs.bankForm.baseData,
              this.$refs.accountForm.baseData,
            ];
            let [bankKeys, accountKeys] = [Object.keys(bankForm), Object.keys(accountForm)];
            bankKeys.map((item) => {
              if (item == 'bankNational' || item == 'bankGroup' || item == 'swiftCode') {
                bankForm[item] = allDetail.sysBankBranch[item];
              } else {
                bankForm[item] = allDetail[item];
              }
            });
            accountKeys.map((item) => {
              if (item == 'bankConnectionFlag') {
                accountForm.bankConnectionFlag = allDetail.bankConnectionFlag == 1 ? true : false;
              } else {
                accountForm[item] = allDetail[item];
              }
            });
          }
        });
      },
      //获取会计科目表
      getAccount() {
        this.$baseRequest.getAccountListByLedgerCode().then((res) => {
          this.sysAccountList = res;
        });
      },
      save(btnType) {
        console.log(this.$refs['bankForm'], '---', this.$refs['accountForm'], btnType);
        let bankForm = this.$refs['bankForm'].exportChildData(btnType);
        console.log(bankForm);
        let accountForm = this.$refs['accountForm'].exportChildData(btnType);
        console.log(bankForm, accountForm);
        if (bankForm && accountForm) {
          let params = this.$baseRequest.assignObj({ ...bankForm, ...accountForm });
          loading.startLoading();
          this.$axios.post(API.SAVE_BANKACCOUNT, params).then((res) => {
            loading.endLoading();
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: this.$t('message.success'),
                type: 'success',
              });
              this.returnPath();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        }
      },
      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/bankAccount/bankAccountList',
            name: 'bankAccountList',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
